import { InputSkeleton, TextareaSkeleton } from '@/_components';
import {
  CardContainer,
  Container,
  ContainerLayout,
  FormLayout,
  LeftSection,
  RightSection,
  SectionHeadingSkeleton,
  StickyPageHeaderSkeleton,
} from '@/_containers';
import { RichTextLoader } from '@/_containers/inputs/rich-text';
import { Loading as ViewLogLoading } from '@/_containers/view-logs/loading';

const fieldClass = 'col-span-12 sm:col-span-6';

export default function Loading() {
  return (
    <ContainerLayout>
      <StickyPageHeaderSkeleton withBreadcrumb />

      <Container>
        <LeftSection>
          <CardContainer>
            <SectionHeadingSkeleton withIcon={false} />
            <FormLayout>
              <InputSkeleton className={fieldClass} />
              <InputSkeleton className={fieldClass} />
              <InputSkeleton className={fieldClass} />
              <div className={fieldClass} />
              <TextareaSkeleton className="col-span-12" />
            </FormLayout>
          </CardContainer>

          <CardContainer>
            <SectionHeadingSkeleton withIcon={false} />
            <FormLayout>
              <InputSkeleton className={fieldClass} />
              <InputSkeleton className={fieldClass} />
              <InputSkeleton className={fieldClass} />
              <InputSkeleton className={fieldClass} />
              <InputSkeleton className={fieldClass} />
            </FormLayout>
          </CardContainer>

          <CardContainer>
            <SectionHeadingSkeleton withIcon={false} />
            <FormLayout>
              <InputSkeleton className={fieldClass} />
              <InputSkeleton className={fieldClass} />
              <InputSkeleton className={fieldClass} />
              <TextareaSkeleton className="col-span-12" />
              <InputSkeleton className="col-span-12 h-20" />
            </FormLayout>
          </CardContainer>

          <CardContainer>
            <SectionHeadingSkeleton />
            <FormLayout>
              <InputSkeleton className="col-span-12" />
              <RichTextLoader inline className="col-span-12" withLabel />
            </FormLayout>
          </CardContainer>
        </LeftSection>

        <RightSection>
          <CardContainer right bodyClassName="3xl:pr-0 pr-0">
            <ViewLogLoading />
          </CardContainer>
        </RightSection>
      </Container>
    </ContainerLayout>
  );
}
